import { devConfig } from "./dev";
import { productionConfig } from "./production";

const domain = window.location.hostname;
const subDomain = domain.split(".")[0];
export const dynamicConfig = subDomain === "app" ? productionConfig : devConfig;
